/* eslint-disable */
export default {
    namespaced: true,
    state: () => ({
        hotOdds: null,
        hotNumbers: null,
        isHotNumbersFetching: false,
    }),
    mutations: {
        SET_HOT_ODDS(state, hotOdds) {
            state.hotOdds = hotOdds;
        },
        SET_HOT_NUMBERS(state, hotNumbers) {
            state.hotNumbers = hotNumbers;
        },
        SET_IS_HOT_NUMBER_FETCHING(state, status) {
            state.isHotNumbersFetching = status;
        },
    },
    actions: {
        async fetchHotNumbers({ commit }) {
            commit('SET_IS_HOT_NUMBER_FETCHING', true);
            try {
                const res = await axios.get('/twod-setting/hot-numbers');
                console.log("RESPONS", res)
                commit('SET_HOT_NUMBERS', res.data.hot_numbers);
                commit('SET_HOT_ODDS', res.data.hot_odds);
            } catch (e) {
                console.error(e);
                commit('SET_HOT_ODDS', null);
                commit('SET_HOT_NUMBERS', null);
            } finally {
                commit('SET_IS_HOT_NUMBER_FETCHING', false);
            }
        },

        async updateHotNumbers({ commit, dispatch }, payload) {
            try {
                const res = await axios.post('/twod-setting/hot-numbers', payload);
                commit('SET_HOT_NUMBERS', res.data);
                await dispatch('fetchHotNumbers');
            } catch (error) {
                console.error('Failed to update:', error);
                throw error.response?.data || error;
            }
        },
    },
};
